import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { ClipboardModule } from 'ngx-clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthService } from './modules/auth/_services/auth.service';
import { environment } from 'src/environments/environment';
// Highlight JS
import { HighlightModule, HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { SplashScreenModule } from './_metronic/partials/layout/splash-screen/splash-screen.module';
// #fake-start#
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
// import { FakeAPIService } from './_fake/fake-api.service';
import { MatTabsModule } from '@angular/material/tabs';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { SubserviceService } from './service/subservice.service';
import { MainService } from './service/mainservice';

import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import {TranslationModule} from '../app/modules/i18n/translation.module';
import { LoadingInterceptor } from './loader/loading.interceptor';
import { LoaderComponent } from './loader/loader.component';
import { LoadingService } from './loader/loading.service';
// import {  MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OverlayModule } from '@angular/cdk/overlay';
import { ChartModule } from 'angular-highcharts';

import { MsalModule,
  MsalService,
  MSAL_INSTANCE } from '@azure/msal-angular';

  import { IPublicClientApplication,
    PublicClientApplication,
    BrowserCacheLocation } from '@azure/msal-browser';

    import { OAuthSettings } from '../app/modules/auth/ms-oauth';
import { MsAuthService } from './modules/auth/auth.service';
  

// #fake-end#

// function appInitializer(authService: AuthService) {
//   return () => {
//     return new Promise((resolve) => {
//       authService.getUserByToken().subscribe().add(resolve);
//     });                                                                                     
//   };
// }

// <MSALFactorySnippet>
let msalInstance: IPublicClientApplication | undefined = undefined;

export function MSALInstanceFactory(): IPublicClientApplication {
  msalInstance = msalInstance ?? new PublicClientApplication({
    auth: {
      clientId: OAuthSettings.appId,
      redirectUri: OAuthSettings.redirectUri,
      postLogoutRedirectUri: OAuthSettings.redirectUri
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    }
  });

  return msalInstance;
}
// </MSALFactorySnippet>


@NgModule({
  declarations: [AppComponent, LoaderComponent],
  imports: [                                                                                                                                                                                                                                                                                                                                                                                                                                  
    BrowserModule,
    BrowserAnimationsModule,
    SplashScreenModule,
    TranslateModule.forRoot(),
    HttpClientModule,
    CommonModule,
    // TranslationModule,
    // HighlightModule,
    // ClipboardModule,
    // MatTabsModule,
    // CarouselModule,
    // CollapseModule,
    // MatSlideToggleModule,
    // FormsModule,
    // ReactiveFormsModule,
    // OverlayModule,
    // ChartModule,
    AppRoutingModule,
    // InlineSVGModule.forRoot(),
    // NgbModule,
    MatProgressSpinnerModule, 
    MsalModule
  ],
  providers: [
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: appInitializer,
    //   multi: true,
    //   deps: [AuthService], 
    // },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    MsalService,
    {
      provide:MsAuthService
    },
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        coreLibraryLoader: () => import('highlight.js/lib/core'),
        languages: {
          xml: () => import('highlight.js/lib/languages/xml'),
          typescript: () => import('highlight.js/lib/languages/typescript'),
          scss: () => import('highlight.js/lib/languages/scss'),
          json: () => import('highlight.js/lib/languages/json')
        },
      },
    },
    SubserviceService,
    MainService,
    LoadingService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
